import * as React from 'react';
import { connect } from 'dva';
import { Dispatch } from 'redux';
import { ConnectState, DiscoverPageModelState } from '@/models/connect';
import styles from './index.less';
import {
  OnClickLoadMoreBtnAction,
  OnUnmountMarketPageAction,
  OnMountMarketPageAction,
  OnChange_SelectedOperationCategoryIDs_Action,
  OnChange_FilterSelected_Action,
} from '@/models/discoverPage';
import FResourceCard from '@/components/FResourceCard';
import { Button } from 'antd';
import FNoDataTip from '@/components/FNoDataTip';
import { FI18n, FUtil } from '@freelog/tools-lib';
import FLoadingTip from '@/components/FLoadingTip';
import * as AHooks from 'ahooks';
import FOperationCategoryFilter from '@/components/FOperationCategoryFilter';
import FSelect2 from '@/components/FSelect2';

interface MarketProps {
  dispatch: Dispatch;
  discoverPage: DiscoverPageModelState;
}

function Market({ dispatch, discoverPage }: MarketProps) {
  const ref_Root = React.useRef<HTMLDivElement>(null);

  AHooks.useMount(() => {
    dispatch<OnMountMarketPageAction>({
      type: 'discoverPage/onMountMarketPage',
    });
  });

  AHooks.useUnmount(() => {
    dispatch<OnUnmountMarketPageAction>({
      type: 'discoverPage/onUnmountMarketPage',
    });
  });

  return (
    <>
      <div ref={ref_Root}>
        <FOperationCategoryFilter
          value={discoverPage.selectedOperationCategoryIDs}
          onChange={(value) => {
            // console.log(value);
            dispatch<OnChange_SelectedOperationCategoryIDs_Action>({
              type: 'discoverPage/onChange_SelectedOperationCategoryIDs',
              payload: {
                value: value,
              },
            });
          }}
        />

        <div style={{ height: 20 }} />
        {/* Figma：下拉选择器 38高 / 白底 / #E4E7EB 边框 / 4圆角 */}
        <FSelect2
          className={styles.filterSelect}
          value={discoverPage.filterSelected}
          options={[
            {
              value: '4,5',
              // 首页推荐
              label: FI18n.i18nNext.tAuto('discover_resource_filter_homepagerecommended'),
            },
            { value: '5', label: '编辑精选' },
            { value: '3,4,5', label: '最新发布' },
          ]}
          popupMatchSelectWidth={false}
          getPopupContainer={() => ref_Root.current as HTMLElement}
          onChange={(value) => {
            dispatch<OnChange_FilterSelected_Action>({
              type: 'discoverPage/onChange_FilterSelected',
              payload: {
                value: value as '4,5' | '5' | '3,4,5',
              },
            });
          }}
        />
      </div>

      {discoverPage.totalItem === -1 && (
        <FLoadingTip height={'calc(100vh - 70px - 140px - 80px - 52px - 52px - 100px)'} />
      )}

      {discoverPage.dataSource.length > 0 ? (
        <>
          <div style={{ height: 20 }} />
          <div className={styles.Content}>
            {discoverPage.dataSource.map((resource) => (
              <FResourceCard
                key={resource.id}
                resource={resource}
                onClick={() => {
                  if (resource.collection) {
                    window.open(
                      FUtil.LinkTo.collectionDetails({
                        collectionID: resource.id,
                      }),
                    );
                  } else {
                    window.open(
                      FUtil.LinkTo.resourceDetails({
                        resourceID: resource.id,
                      }),
                    );
                  }
                }}
              />
            ))}
          </div>

          {discoverPage.totalItem > discoverPage.dataSource.length && (
            <>
              <div style={{ height: 100 }} />
              <div className={styles.bottom}>
                <Button
                  className={styles.loadMore}
                  onClick={() => {
                    dispatch<OnClickLoadMoreBtnAction>({
                      type: 'discoverPage/onClickLoadMoreBtn',
                    });
                  }}
                >
                  加载更多
                </Button>
              </div>
            </>
          )}
          <div style={{ height: 200 }} />
        </>
      ) : discoverPage.totalItem === 0 ? (
        <FNoDataTip height={'calc(100vh - 275px - 52px)'} tipText={'没有符合条件的资源'} />
      ) : null}
    </>
  );
}

export default connect(({ discoverPage }: ConnectState) => ({
  discoverPage: discoverPage,
}))(Market);

// interface Labels {
//   options: {
//     value: string;
//     text?: string;
//   }[];
//   value: string;
//   onChange?: (value: string) => void;
// }
//
// function Labels({ options, value, onChange }: Labels) {
//   return (
//     <div>
//       {options.map((i, j) => (
//         <a
//           key={i.value}
//           className={styles.filterTag + ' ' + (i.value === value ? styles.filterTagActive : '')}
//           onClick={() => onChange && onChange(i.value)}
//         >
//           {i.text || i.value}
//         </a>
//       ))}
//     </div>
//   );
// }
